module.exports = __webpack_public_path__ + "img/gallery14.5c5bf760.jpg";